import React from 'react';
import PropTypes from 'prop-types';
import {Box, CircularProgress, Grid, Typography, useMediaQuery, useTheme} from '@material-ui/core';
import {AzoButton} from "../../../index";
import useStyles from "./StopoverWithExperiencesStyles";
import StopoverWithExperiencesModal from "./resources/StopoverWithExperiencesModal";

const StopoverWithExperiences = ({buttonText, title, subtitle, onClick, submitting, canSubmit, form, disabled}) => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const classes = useStyles(isMobile);

    return (
        <Box className={classes.container}>
            <Grid spacing={2} container>
                <Grid xs={12} sm={7} md={7} item>
                    <Typography className={classes.title} variant={'h6'}>
                        {title}
                    </Typography>
                    <Typography className={classes.subtitle} variant={'subtitle2'}>
                        {subtitle}
                    </Typography>
                </Grid>
                <Grid xs={12} sm={5} md={5} className={classes.btnGrid} item>
                    {canSubmit && form}
                    {submitting && <StopoverWithExperiencesModal />}
                    <AzoButton
                        onClick={onClick}
                        disabled={disabled}
                        variant={'contained'}
                        color={'secondary'}
                        size={'small'}
                        style={{maxWidth: '190px', maxHeight: '40px'}}
                        fullWidth>
                        {submitting ? <CircularProgress /> : <Typography variant={'subtitle1'}>{buttonText}</Typography>}
                    </AzoButton>
                </Grid>
            </Grid>
        </Box>
    );
};

StopoverWithExperiences.propTypes = {
    buttonText: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    submitting: PropTypes.bool,
};

StopoverWithExperiences.defaultProps = {
    buttonText: '',
    title: null,
    subtitle: null,
    onClick: null,
    disabled: false,
    submitting: false,
};

export default StopoverWithExperiences;